import { useSelector } from 'react-redux'
import { Table } from '../../../../../common/table'
import {
  changeCashFlowStatementIds,
  selectCashFlowStatementChildIds,
  selectCashFlowStatementIds,
  selectCashFlowStatementItem,
  selectCashFlowStatementParentId,
  selectCashFlowStatementRowData,
  selectIsLoading,
  selectTableHeader,
} from '../store/slice'
import { CustomTHead } from '../table/CustomTHead'
import { FinancialStatementsValueCell } from '../table/FinancialStatementsValueCell'
import { FirstColumnCell } from '../table/firstColumnCell/FirstColumnCell'

export const CashFlowsStatement = () => {
  const cashFlowsStatementIds = useSelector(selectCashFlowStatementIds)
  const isLoading = useSelector(selectIsLoading)
  const tableHeader = useSelector(selectTableHeader)

  return (
    <Table
      ids={cashFlowsStatementIds}
      getDataFromRedux={selectCashFlowStatementItem}
      isLoading={isLoading}
      isNoDataWithHead={true}
      autoHeightMax={400}
      renderTHead={() => <CustomTHead tableTitle={tableHeader} />}
      schema={tableHeader.map((item, index) => {
        const title = item.title
        const colId = `${item.colId}`

        const result = {
          title,
          colId,
        }
        if (index === 0) {
          return {
            ...result,
            render: (val, { rowId }) => {
              return (
                <FirstColumnCell
                  ids={cashFlowsStatementIds}
                  rowId={rowId}
                  val={val}
                  selectRowData={selectCashFlowStatementRowData}
                  selectChildIds={selectCashFlowStatementChildIds}
                  selectParentIds={selectCashFlowStatementParentId}
                  changeIds={changeCashFlowStatementIds}
                  tabName="cashFlows"
                />
              )
            },
          }
        }
        return {
          ...result,
          render: (val) => {
            return <FinancialStatementsValueCell val={val} />
          },
        }
      })}
    />
  )
}
